import React from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {additionalEmailAPI, IAdditionalEmailAdd} from 'entities/notification';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import EmailInput from 'shared/ui/Input/InputEmail';
import InputText from 'shared/ui/Input/InputText';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {TypedDispatch} from 'shared/model/types';
import {fetchMe} from 'entities/user';
import {validateDescription} from 'features/profile/lib/validateDescription';

interface IAdditionalEmailFormProps {
    onSuccess: () => void,
    onClose: () => void,
}

const AdditionalEmailForm: React.FC<IAdditionalEmailFormProps> = ({onSuccess, onClose}) => {
    const {register, handleSubmit, formState, control, watch} = useForm<IAdditionalEmailAdd>({mode: 'onChange'});
    const {errors} = formState;
    const dispatch = useDispatch<TypedDispatch>();

    const emailValue = watch('email');
    const descriptionValue = watch('description');
    const isFormValid = emailValue?.trim() && descriptionValue?.trim();

    const [addAdditionalChat, {isLoading}] = additionalEmailAPI.useAddWithConfirmedMutation();

    const onSubmit: SubmitHandler<IAdditionalEmailAdd> = async(data) => {
        const result = await addAdditionalChat({
            email: data.email.trim(),
            description: data.description.trim(),
        });
        if ('error' in result) return;
        toast.info(result.data.message ?? t`Отправлено сообщение для подтверждения Email`);
        dispatch(fetchMe());
        onSuccess();
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBodyWrapper>
                    <FormGroupWithError
                        error={errors?.email?.message}
                        label={t`E-mail`}
                    >
                        <EmailInput
                            control={control}
                            name="email"
                            placeholder={t`example@example.ru`}
                            register={register}
                            required
                        />
                    </FormGroupWithError>
                    <FormGroupWithError
                        error={errors?.description?.message}
                        label={t`Описание`}
                    >
                        <InputText
                            control={control}
                            name="description"
                            placeholder={t`Краткое описание`}
                            register={register}
                            validate
                            rules={{
                                required: t`Описание обязательно для заполнения`,
                                validate: validateDescription,
                            }}
                        />
                    </FormGroupWithError>
                </ModalBodyWrapper>
                <ModalBlockButton
                    primaryButtonText={t`Добавить`}
                    primaryButtonType="submit"
                    primaryButtonLoading={isLoading}
                    primaryButtonDisabled={!isFormValid || isLoading}
                    secondaryButtonOnClick={onClose}
                />
            </form>
        </div>
    );
};

export default AdditionalEmailForm;